/*
  from: https://projects.lukehaas.me/css-loaders/
 */

.loader,
.loader:after {
  border-radius: 50%;
}
.loader {
  /*margin: 60px auto;*/
  position: relative;
  text-indent: -9999em;
  border-top: 2.75px solid rgba(255, 255, 255, 0.2);
  border-right: 2.75px solid rgba(255, 255, 255, 0.2);
  border-bottom: 2.75px solid rgba(255, 255, 255, 0.2);
  border-left: 2.75px solid black;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

/* these are the interesting bits we can easily change from the above */
.default-style {
  /* the 'track' color */
  border-color: rgba(255, 255, 255, 0.2);
  /* color of the spinning thing */
  border-left-color: black;
  animation-duration: 0.8s;

  &.dark-bg-style {
    border-left-color: white;
  }
}
